import {
	type ClientPortfolioDetailBankProductToolResponseDTO,
	type ClientPortfolioDetailBondToolResponseDTO,
	type ClientPortfolioDetailCommodityToolResponseDTO,
	type ClientPortfolioDetailCryptocurrencyToolResponseDTO,
	type ClientPortfolioDetailFundToolResponseDTO,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	type NormalizedTool,
	ToolKind,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import {
	normalizeBankInstruction,
	normalizeBondInstruction,
	normalizeCommodityInstruction,
	normalizeCryptoInstruction,
	normalizeFundInstruction,
} from "web_myplann/Portfolio/Helpers/normalizeTools";

type InstrumentDetail =
	| ClientPortfolioDetailFundToolResponseDTO
	| ClientPortfolioDetailBondToolResponseDTO
	| ClientPortfolioDetailCommodityToolResponseDTO
	| ClientPortfolioDetailCryptocurrencyToolResponseDTO
	| ClientPortfolioDetailBankProductToolResponseDTO;

export const normalizeInstrument = (
	instrument: InstrumentDetail | null | undefined,
): NormalizedTool | undefined => {
	if (!instrument) {
		return undefined;
	}

	const base = {
		id: instrument.id,
		identificationType: instrument.identificationType,
		identification: instrument.identification,
		name: instrument.name,
		monthlyPayment: instrument.monthlyPayment,
	};

	switch (instrument.type) {
		case ClientPortfolioToolTypeEnum.Bond: {
			const raw = instrument as ClientPortfolioDetailBondToolResponseDTO;
			return {
				...base,
				kind: ToolKind.Bond,
				evaluation: raw.evaluation,
				instructions: raw.instructions.map(normalizeBondInstruction),
				raw,
			};
		}
		case ClientPortfolioToolTypeEnum.Commodity: {
			const raw = instrument as ClientPortfolioDetailCommodityToolResponseDTO;
			return {
				...base,
				kind: ToolKind.Commodity,
				instructions: raw.commodities.map(normalizeCommodityInstruction),
				raw,
			};
		}
		case ClientPortfolioToolTypeEnum.Crypto: {
			const raw =
				instrument as ClientPortfolioDetailCryptocurrencyToolResponseDTO;
			return {
				...base,
				kind: ToolKind.Crypto,
				instructions: raw.cryptocurrencyInstructions.map(
					normalizeCryptoInstruction,
				),
				raw,
			};
		}
		case ClientPortfolioToolTypeEnum.BankProduct: {
			const raw = instrument as ClientPortfolioDetailBankProductToolResponseDTO;
			return {
				...base,
				kind: ToolKind.BankProduct,
				instructions: raw.instructions.map(normalizeBankInstruction),
				raw,
			};
		}
		default: {
			const raw = instrument as ClientPortfolioDetailFundToolResponseDTO;
			return {
				...base,
				kind: ToolKind.Investment,
				type: raw.type,
				evaluation: raw.evaluation,
				instructions: raw.instructions.map(normalizeFundInstruction),
				raw,
			};
		}
	}
};
